module.exports = __webpack_public_path__ + "static/media/panel_bottom_left.e406ed4f.png";